<template>
  <div class="component">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12" style="margin-bottom: 25px">
          <span class="textGray" style="font-size: 20px">Máquina:</span>
          <span style="font-size: 20px">{{ dvs.machine.name }}</span>
        </div>
        <div class="col-12">
          <span style="font-size: 18px">Visão geral da máquina</span>
        </div>
        <div class="col-12" v-if="dvsPhotoUrl">
          <div class="machinePhoto">
            <img :src="dvsPhotoUrl" alt class="image-rounded" style="width: 100%; height: auto; max-width: 500px;"/>
          </div>
        </div>
        <div class="col-12" v-if="!readonly && canAccess()">
          <label class="textGray">Foto principal do DVS</label>
          <div>
            <!-- Era um <input type="file"> cru, so upload pelo explorer. Agora abre o
                 mesmo editor do modal de fotos dos dispositivos, que ja traz o botao
                 "Selecionar do arquivo" apontado para a pasta Fotos DVS da maquina -
                 apontamento passado pelo Marlon em 14/08/2026. -->
            <button
              type="button"
              class="btn btn-secondary"
              v-on:click="openDvsPhotoModal()"
            >
              {{ tempDvsPhoto ? "Trocar foto" : "Escolher foto" }}
            </button>
          </div>
          <small class="textGray">Esta foto é exclusiva deste DVS e não altera a foto usada na Apreciação de Risco.</small>
        </div>
        <div class="col-12">
          <Accordion>
            <template v-slot:title>
              <div
                class="col-12"
                style="margin-top: 35px; margin-bottom: 25px; font-size: 18px"
              >
                <span class="textGray">Informações da máquina:</span>
              </div>
            </template>
            <template v-slot:body>
              <div class="row">
                <div class="col-6">
                  <div class="form-group">
                    <label class="textGray">Setor</label>
                    <input
                      type="text"
                      v-model="dvs.machine.sector"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>

                  <div class="form-group">
                    <label class="textGray">Tipo</label>
                    <input
                      type="text"
                      v-model="dvs.machine.type"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Modelo</label>
                    <input
                      type="text"
                      v-model="dvs.machine.model"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Capacidade</label>
                    <input
                      type="text"
                      v-model="dvs.machine.capacity"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Peso</label>
                    <input
                      type="text"
                      v-model="dvs.machine.weight"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Nº de Série</label>
                    <input
                      type="text"
                      v-model="dvs.machine.serie_number"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                </div>
                <div class="col-6">
                  <div class="form-group">
                    <label class="textGray">Marca</label>
                    <input
                      type="text"
                      v-model="dvs.machine.manufacturer"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Ano de Fabricação (Caso não identificado, deixar em branco)</label>
                    <input
                      type="text"
                      v-model="dvs.machine.manufactured_at"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Tensão</label>
                    <input
                      type="text"
                      v-model="dvs.machine.tension"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Função da Máquina</label>
                    <input
                      type="text"
                      v-model="dvs.machine.machine_function"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <!-- Campos pedidos no apontamento passado pelo Marlon em 14/08/2026.
                       Nao obrigatorios: em branco, a linha nao sai no documento final. -->
                  <div class="form-group">
                    <label class="textGray">Crea</label>
                    <input
                      type="text"
                      v-model="dvs.machine.crea"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Pressão Hidráulica</label>
                    <input
                      type="text"
                      v-model="dvs.machine.hydraulic_pressure"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                  <div class="form-group">
                    <label class="textGray">Pressão Pneumática</label>
                    <input
                      type="text"
                      v-model="dvs.machine.pneumatic_pressure"
                      class="form-control"
                      :disabled="!canAccess()"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label class="textGray">Observações</label>
                    <textarea
                      v-model="dvs.machine.observations"
                      class="form-control"
                      :disabled="!canAccess()"
                    ></textarea>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12" style="padding: 2vh 2vw">
                  <button
                    class="btn btn-success float-right"
                    v-on:click="updateMachine()"
                    v-if="canAccess()"
                  >
                    <span>
                      Salvar Máquina
                      <font-awesome-icon icon="save" />
                    </span>
                  </button>
                </div>
              </div>
            </template>
          </Accordion>
        </div>
        <div
          class="col-12"
          style="margin-top: 35px; margin-bottom: 25px; font-size: 18px"
        >
          <div class="form-group">
            <label class="textGray">Nº ART Vinculada</label>
            <input
              v-model="dvs.linked_art"
              class="form-control"
              :disabled="!canAccess()"
            />
          </div>
          <div class="form-group">
            <label class="textGray">Nº Revisão</label>
            <input
              v-model="dvs.revision_number"
              class="form-control"
              :disabled="!canAccess()"
            />
          </div>
          <div class="form-group">
            <label class="textGray">Introdução</label>
            <textarea
              v-model="dvs.introduction"
              style="width: 100%; height: 25vh"
              class="form-control"
              :disabled="!canAccess()"
            ></textarea>
          </div>
          <div class="form-group">
            <label class="textGray">Escopo</label>
            <textarea
              v-model="dvs.scope"
              style="width: 100%; height: 25vh"
              class="form-control"
              :disabled="!canAccess()"
            ></textarea>
          </div>
          <div class="form-group">
            <label class="textGray">Considerações Finais</label>
            <textarea
              v-model="dvs.final_considerations"
              style="width: 100%; height: 25vh"
              class="form-control"
              :disabled="!canAccess()"
            ></textarea>
          </div>
          <div class="form-group">
            <label class="textGray">Plano de Ação</label>
            <textarea
              v-model="dvs.action_plan"
              style="width: 100%; height: 25vh"
              class="form-control"
              :disabled="!canAccess()"
            ></textarea>
          </div>
          <!-- "Nao ha opcao para inserir a data de inspecao" - apontamento passado pelo
               Marlon em 14/08/2026.
               Antes o PDF usava o updated_at do registro, entao a data se movia a cada
               edicao do documento. -->
          <div class="form-group">
            <label class="textGray">Data da Inspeção</label>
            <input
              type="date"
              v-model="inspectedAtInput"
              class="form-control"
              :disabled="!canAccess()"
            />
            <small class="textGray">Em branco, a linha nao aparece no documento.</small>
          </div>
          <!-- Era um input de texto livre. Virou uma linha por revisao com data,
               apontamento passado pelo Marlon em 14/08/2026. O texto antigo foi
               convertido para ca por migracao e a coluna deixou de ser escrita, para as
               duas nao poderem mais contar historias diferentes. -->
          <div class="form-group">
            <label class="textGray">Controle de Revisões</label>
            <div
              v-for="(revision, index) in revisions"
              :key="index"
              class="row"
              style="margin-bottom: 8px"
            >
              <div class="col-5">
                <input
                  type="text"
                  v-model="revision.label"
                  class="form-control"
                  placeholder="Original, Rev. 01…"
                  :disabled="!canAccess()"
                />
              </div>
              <div class="col-5">
                <input
                  type="date"
                  v-model="revision.revised_at"
                  class="form-control"
                  :disabled="!canAccess()"
                />
              </div>
              <div class="col-2">
                <button
                  type="button"
                  class="btn btn-danger btn-block"
                  title="Remover esta revisão"
                  v-if="canAccess()"
                  v-on:click="removeRevision(index)"
                >
                  <font-awesome-icon icon="times" />
                </button>
              </div>
            </div>
            <button
              type="button"
              class="btn btn-secondary"
              v-if="canAccess()"
              v-on:click="addRevision()"
            >
              + Adicionar nova revisão
            </button>
            <div>
              <small class="textGray">Revisão sem data não aparece no documento. O Nº Revisão acima é sugerido a partir desta lista e continua editável.</small>
            </div>
          </div>
        </div>
      </div>
      <div class="row itens">
        <div
          class="col-12"
          style="margin-top: 35px; margin-bottom: 25px; font-size: 18px"
        >
          <span class="textGray">Descrição dos dispositivos de segurança:</span>
        </div>
        <div class="col-12" v-if="render">
          <div
            class="col-12"
            v-for="(device, index) in dvs.protection_devices"
            v-bind:key="index"
          >
            <Accordion :ref="index">
              <template v-slot:title>
                <div
                  class="col-12"
                  style="margin-top: 35px; margin-bottom: 25px; font-size: 18px"
                >
                  <span class="textGray"
                    >Dispositivo de segurança:
                    {{ device.name ? device.name : "Novo dispositivo" }}</span
                  >
                </div>
              </template>
              <template v-slot:body class="col-12">
                <div class="row securityDevice">
                  <ProtectionDevice
                    ref="protectionDevice"
                    :dvs_id="dvs.id"
                    :machine_id="dvs.machine_id"
                    :device="device"
                    :readonly="readonly"
                    :index="index"
                    @deleteProtectionDevice="deleteProtectionDevice(index)"
                    @saveProtectionDevice="onSaveProtectionDevice($event, index)"
                  ></ProtectionDevice>
                </div>
              </template>
            </Accordion>
          </div>
        </div>
        <div class="col-12" v-if="!readonly">
          <div class="btn btn-secondary float-right">
            <div class="icon" v-on:click="addDevice()">
              <font-awesome-icon icon="plus" />Adicionar Dispositivo de
              Segurança
            </div>
          </div>
        </div>
        <div
          class="col-12 d-flex"
          style="
            margin-top: 50px;
            align-items: center;
            justify-content: flex-end;
          "
          v-if="!readonly"
        >
          <b-spinner label="Small Spinner" v-if="saving"></b-spinner>
          <button
            class="btn btn-success"
            style="margin-right: 26px"
            v-on:click="saveDVS()"
          >
            <span>Salvar Documento <font-awesome-icon icon="save" /> </span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-padding">
          <b-alert v-show="alert" :variant="alert_type" show>{{
            alert_msg
          }}</b-alert>
          <b-alert
            dismissible
            @dismissed="dismissCountDown = 0"
            @dismiss-count-down="countDownChanged"
            fade
            :show="dismissCountDown"
            variant="warning"
            >Você possui um ou mais dispositivos de segurança sem salvar. Por
            favor, salve tudo para continuar</b-alert
          >
          <div class="alertError" style="width: 100%; height: 50px"></div>
        </div>
      </div>
    </div>
    <b-modal ref="dvs-photo-modal" size="xl" title="Foto principal do DVS" @ok="saveDvsPhoto()">
      <ImageEditor
        ref="dvsImageEditor"
        :machine_id="dvs.machine ? dvs.machine.id : null"
        :selected-directory="'Fotos DVS'"
        :company_id="company_id"
      ></ImageEditor>
      <template v-slot:modal-cancel>Cancelar</template>
      <template v-slot:modal-ok>Usar esta foto</template>
    </b-modal>
  </div>
</template>
<script>
import axios from "@/api/axios";
import Accordion from "@/components/Accordion.vue";
import ProtectionDevice from "@/components/ProtectionDevice.vue";
import ImageEditor from "@/components/ImageEditor.vue";
import { canAccess } from "@/utils/canAccess";
import moment from "moment";

export default {
  name: "security-validation",
  components: {
    ProtectionDevice,
    Accordion,
    ImageEditor,
  },
  data() {
    return {
      render: false,
      saving: false,
      alert: false,
      alert_type: "success",
      alert_msg: "Item salvo com sucesso",
      registersStack: [],
      dismissSecs: 8,
      dismissCountDown: 0,
      tempDvsPhoto: "",
      revisions: [],
    };
  },
  computed: {
    dvsPhotoUrl: function () {
      if (this.tempDvsPhoto) {
        return this.tempDvsPhoto;
      }
      if (this.dvs.photo && this.dvs.photo.url) {
        return this.dvs.photo.url;
      }
      return this.dvs.machine.photo ? this.dvs.machine.photo.url : "";
    },
    // A API devolve a data em ISO completo ("2026-08-20T00:00:00.000000Z") e o
    // <input type="date"> so aceita YYYY-MM-DD, entao a conversao fica aqui em vez de
    // espalhada pelo template.
    inspectedAtInput: {
      get() {
        const value = this.dvs.inspected_at;
        if (!value) {
          return "";
        }
        return String(value).slice(0, 10);
      },
      set(value) {
        this.$set(this.dvs, "inspected_at", value || null);
      },
    },
  },
  props: {
    dvs: {},
    readonly: {
      type: Boolean,
      default: false,
    },
    selectedResponsibles: {
      type: Array,
      default: () => []
    },
    company_id: {
      type: String,
      default: () => localStorage.getItem('company_id'),
    },
  },
  mounted() {
    this.render = false;
    this.loadRevisions();
    this.render = true;
  },
  watch: {
    alert: function () {
      const vm = this;
      setTimeout(() => {
        vm.alert = false;
      }, 3000);
    },
    // O componente pode montar antes do DVS chegar da API; sem isto a lista de revisoes
    // ficaria vazia na tela mesmo havendo revisoes gravadas.
    "dvs.id": function () {
      this.loadRevisions();
    },
  },
  methods: {
    canAccess,
    addDevice: function () {
      this.registersStack.push("um dispositivo de segurança");
      this.render = false;
      if (!this.dvs.protection_devices) {
        this.dvs.protection_devices = [];
      }
      this.dvs.protection_devices.push({});

      // var i = 0;
      // for (i = 0; i < this.dvs.protection_devices.length - 1; i++)
      //   this.$refs[i][0].active = false;

      this.render = true;
    },
    onSaveProtectionDevice: function (newDevice, index) {
      this.$set(this.dvs.protection_devices, index, newDevice);
      this.$emit("dvsChange", this.dvs);
      // this.registersStack.pop();
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    loadRevisions: function () {
      // A API devolve a data em ISO completo e o <input type="date"> quer YYYY-MM-DD.
      const vindas = (this.dvs && this.dvs.revisions) || [];
      this.revisions = vindas.map((r) => ({
        label: r.label || "",
        revised_at: r.revised_at ? String(r.revised_at).slice(0, 10) : "",
      }));
    },
    // "00" com so a Original, "01" com uma revisao, e assim por diante. Roda ao
    // adicionar ou remover, nao no carregamento: assim o numero de documento que ja
    // existe nunca e mexido por baixo do pano, e segue editavel a mao.
    suggestRevisionNumber: function () {
      const n = Math.max(this.revisions.length - 1, 0);
      this.$set(this.dvs, "revision_number", String(n).padStart(2, "0"));
    },
    addRevision: function () {
      const label =
        this.revisions.length === 0
          ? "Original"
          : "Rev. " + String(this.revisions.length).padStart(2, "0");
      this.revisions.push({ label: label, revised_at: "" });
      this.suggestRevisionNumber();
    },
    removeRevision: function (index) {
      this.revisions.splice(index, 1);
      this.suggestRevisionNumber();
    },
    openDvsPhotoModal: function () {
      if (this.$refs.dvsImageEditor) {
        this.$refs.dvsImageEditor.resetCanvas();
      }
      this.$refs["dvs-photo-modal"].show();
    },
    saveDvsPhoto: function () {
      // getImageEdit() devolve o data URL do canvas, tanto para foto vinda do upload
      // quanto para foto escolhida da pasta - o payload do DVS ja espera esse formato
      // em `image`, entao nada muda do lado da API.
      const image = this.$refs.dvsImageEditor.getImageEdit();
      if (image) {
        this.tempDvsPhoto = image;
      }
    },
    uploadDvsPhoto: function (e) {
      const file = e.target.files[0];
      if (!file || !file.type.includes("image/")) {
        return;
      }
      const reader = new FileReader();
      reader.onload = (event) => {
        this.tempDvsPhoto = event.target.result;
      };
      reader.readAsDataURL(file);
    },
    updateMachine: function () {
      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/machines/` +
            this.dvs.machine.id,
          {
            name: this.dvs.machine.name,
            sector: this.dvs.machine.sector,
            type: this.dvs.machine.type,
            model: this.dvs.machine.model,
            capacity: this.dvs.machine.capacity,
            weight: this.dvs.machine.weight,
            crea: this.dvs.machine.crea,
            hydraulic_pressure: this.dvs.machine.hydraulic_pressure,
            pneumatic_pressure: this.dvs.machine.pneumatic_pressure,
            manufacturer: this.dvs.machine.manufacturer,
            manufactured_at: this.dvs.machine.manufactured_at,
            tension: this.dvs.machine.tension,
            serie_number: this.dvs.machine.serie_number,
            machine_function: this.dvs.machine.machine_function,
            observations: this.dvs.machine.observations,
          }
        )
        .then(() => {
          this.$bvToast.toast("Máquina atualizada com sucesso!", {
            title: "Sucesso",
            variant: "success",
            solid: true,
            toaster: "b-toaster-top-center",
          });
        })
        .catch(() => {
          this.$bvToast.toast("Não foi possível salvar os dados da máquina. Por favor tente novamente!", {
            title: "Ocorreu um erro",
            variant: "danger",
            solid: true,
            toaster: "b-toaster-top-center",
          });
        });
    },
    saveDVS: function () {
      if (this.$refs.protectionDevice) {
        this.$refs.protectionDevice.forEach((el) => {
          el.save();
        });
      }

      this.saving = true;

      axios
        .put(
          `${process.env.VUE_APP_API_HOST}/api/admin/security-validations/` +
            this.dvs.id,
          {
            linked_art: this.dvs.linked_art,
            revision_number: this.dvs.revision_number,
            introduction: this.dvs.introduction,
            scope: this.dvs.scope,
            final_considerations: this.dvs.final_considerations,
            action_plan: this.dvs.action_plan,
            inspected_at: this.dvs.inspected_at || null,
            // Sempre enviado, inclusive vazio: a API distingue "chave ausente" de
            // "lista vazia", e enviar sempre e o que permite apagar a ultima revisao.
            revisions: this.revisions
              .filter((r) => (r.label || "").trim() !== "")
              .map((r, i) => ({
                label: r.label.trim(),
                revised_at: r.revised_at || null,
                order: i,
              })),
            machine_id: this.dvs.machine_id,
            number_code: this.dvs.number_code,
            security_validation_id: this.dvs.id,
            user_id: localStorage.getItem("auth.user_id"),
            technical_responsibles: this.selectedResponsibles,
            image: this.tempDvsPhoto || undefined
          }
        )
        .then((response) => {
          this.securityValidation = response.data;
          this.securityValidation.machine = this.machineSelected;
          this.tempDvsPhoto = "";
          this.saving = false;
          this.alert_type = "success";
          this.alert_msg = "Item Salvo com sucesso";
          
          localStorage.setItem('dvs_success_notification', 'true');
          
          setTimeout(() => {
            this.success = false;
            this.$router.push({
              name: 'ListDocuments',
              params: {
                company_id: this.company_id,
                doctype: 'DVS',
                docTypeText: 'DVS'
              }
            });
          }, 1500);
        })
        .catch(() => {
          this.warning = true;
          this.saving = false;
          this.alert_type = "warning";
          this.alert_msg = "Ocorreu um erro";
          this.alert = true;
        });
    },
    formatDate: function (date) {
      return moment(date).format("YYYY");
    },
    deleteProtectionDevice: function (val) {
      this.dvs.protection_devices.splice(val, 1);
    },
    scrollToElement() {
      const el = this.$el.getElementsByClassName("alertError")[0];
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
      }
    },
  },
};
</script>
